import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './ExportChemquoteButton.custom.scss';

export default function ExportChemquoteButton(props) {
  const { isExportEnabled, chemquoteEnabled, openExportDialog, isSubstancesContext } = props;

  if (!isSubstancesContext || !chemquoteEnabled) {
    return null;
  }

  return (
    <Button
      id="exportChemquote"
      onClick={() => {
        openExportDialog('ChemQuote');
      }}
      disabled={!isExportEnabled}
      buttonConfig={{
        className: 'result-toolbar-export-chemquote-button',
        label: 'Novartis ChemQuote',
        type: 'link',
        size: 'tiny',
        e2eName: 'export-chemquote',
      }}
      iconConfig={{
        position: 'before',
        name: 'upload',
        size: 'sm',
      }}
    />
  );
}

ExportChemquoteButton.defaultProps = {
  openExportDialog: () => {
    Logger.error('openExportDialog something went wrong, value from ng is not a function');
  },
};

ExportChemquoteButton.propTypes = {
  isExportEnabled: PropTypes.bool,
  openExportDialog: PropTypes.func,
  chemquoteEnabled: PropTypes.bool,
  isSubstancesContext: PropTypes.bool.isRequired,
};
